/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SBE SMS API
 * SMS API. AccessTokenGuard 보호 라우트는 Authorization: Bearer <jwt> 가 필요.
 * OpenAPI spec version: 1.0
 */

export type OriginatorDocumentType = typeof OriginatorDocumentType[keyof typeof OriginatorDocumentType];


export const OriginatorDocumentType = {
  TelecomSubscription: 'TelecomSubscription',
  BusinessRegistration: 'BusinessRegistration',
  EmploymentCert: 'EmploymentCert',
  IdCard: 'IdCard',
} as const;
